<template>
  <SoRadioCard :value="value">
    <template #title>
      <div class="d-flex align-center">
        <SoAvatar :type="isElectricity ? 'electric' : 'gas'" class="mr-2" />
        <slot v-if="$slots.title" name="title"></slot>
        <h5 v-else>{{ isElectricity ? "Electricity" : "Gas" }}</h5>
        <v-spacer />
        <div class="text-disabled font-weight-medium">
          {{
            tariffQuoter.selectedFuels.includes(value)
              ? "Selected &#10003;"
              : ""
          }}
        </div>
      </div>
    </template>
    <slot></slot>

    <SoDivider />
    <UsageEstimator
      :is-electricity="isElectricity"
      collapsible
      class="mt-4"
      @updated="($event) => update($event)"
    >
      <template #prepend>
        <b>Usage Estimation:</b>
      </template>
    </UsageEstimator>
  </SoRadioCard>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter, FuelType } from "@/stores/tariffQuoter"
  import { IUsageEstimation } from "@/services/UsageEstimationService/types"
  import SoAvatar from "@/components/SoAvatar.vue"
  import SoRadioCard from "@/components/SoRadioCard.vue"
  import SoDivider from "@/components/SoDivider.vue"
  import UsageEstimator from "@/views/customer/components/UsageEstimator"

  export default defineComponent({
    components: {
      SoAvatar,
      SoRadioCard,
      SoDivider,
      UsageEstimator,
    },
    props: {
      isElectricity: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
      }
    },
    computed: {
      value(): FuelType {
        return this.isElectricity ? "electricity" : "gas"
      },
    },
    methods: {
      update(usage: Partial<IUsageEstimation>) {
        if (this.isElectricity) {
          if (
            typeof usage.electricityDay === "number" ||
            typeof usage.electricityNight === "number"
          ) {
            this.tariffQuoter.fuelEstimation.electricityDay =
              usage.electricityDay
            this.tariffQuoter.fuelEstimation.electricityNight =
              usage.electricityNight
            this.tariffQuoter.fuelEstimation.electricity = undefined
          } else {
            this.tariffQuoter.fuelEstimation.electricity = usage.electricity
            this.tariffQuoter.fuelEstimation.electricityDay = undefined
            this.tariffQuoter.fuelEstimation.electricityNight = undefined
          }
        } else {
          this.tariffQuoter.fuelEstimation.gas = usage.gas
        }
        this.tariffQuoter.fuelUsage = { ...this.tariffQuoter.fuelEstimation }
        this.tariffQuoter.setMeterpointFuelUsage()
      },
    },
  })
</script>
